// document.addEventListener("DOMContentLoaded",()=> {
//     let description = document.querySelector('.collection-description')
//     if(description){
//       let descriptionFull = description.querySelector('.collection-description__big__full')
//       let descriptionTrimmed = description.querySelector('.collection-description__big__trimmed')
//       let descriptionBtnLess = description.querySelector('.collection-description__button.show-less')
//       let descriptionBtnMore = description.querySelector('.collection-description__button.show-more')

//       descriptionBtnMore.addEventListener("click",(e)=> {
//         e.preventDefault();
//         descriptionTrimmed.style.display = "none"
//         descriptionFull.style.display = "block"
//       })

//       descriptionBtnLess.addEventListener("click",(e)=> {
//         e.preventDefault();
//         descriptionFull.style.display = "none"
//         descriptionTrimmed.style.display = "block"
//       })
//     }
//   })

document.addEventListener('DOMContentLoaded', function () {
    const dropdownButton = document.querySelector('.custom-dropdown__button');
    const dropdownList = document.querySelector('.custom-dropdown__list');
    const dropdownOptions = document.querySelectorAll('.custom-dropdown__option');
    const selectElements = document.querySelectorAll('#SortBy');
    const selectedText = document.querySelector('.custom-dropdown__selected');

    dropdownButton.addEventListener('click', function () {
        const isExpanded = dropdownButton.getAttribute('aria-expanded') === 'true';
        dropdownButton.setAttribute('aria-expanded', !isExpanded);
        dropdownList.style.display = isExpanded ? 'none' : 'block';
    });

    dropdownOptions.forEach(option => {
        option.addEventListener('click', function () {
            const value = option.getAttribute('data-value');
            selectedText.textContent = option.textContent;
            dropdownOptions.forEach(opt => opt.removeAttribute('data-selected'));
            option.setAttribute('data-selected', 'true');

            selectElements.forEach(selectElement =>{
              selectElement.value = value;
              selectElement.dispatchEvent(new Event('change'));
            });
            document.getElementById('test-box').click();

            dropdownButton.setAttribute('aria-expanded', 'false');
            dropdownList.style.display = 'none';
        });
    });

    document.addEventListener('click', function (event) {
        if (!dropdownButton.contains(event.target) && !dropdownList.contains(event.target)) {
            dropdownButton.setAttribute('aria-expanded', 'false');
            dropdownList.style.display = 'none';
        }
    });
});

class ProductPerLine extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('[data-items]');
    this.productGrid = document.querySelector('#product-grid');
  }

  setEventListeners() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.productGrid = document.querySelector('#product-grid');
        this.fetchCartAttr(button.dataset.items);
        this.buttons.forEach(innerBtn => {
          innerBtn.classList.remove('mobile-facets__wrapper-product-per-line__item--active');
        });
        button.classList.add('mobile-facets__wrapper-product-per-line__item--active');
      });
    });
  }

  fetchCartAttr(items) {
    this.productGrid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
    this.productGrid.classList.add(`grid--${items}-col-desktop`);
    
    let xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart.js', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    
    let data = "attributes[pagination]=" + encodeURIComponent(items);

    xhr.onload = function () {
      if (xhr.status === 200) {
        // window.location.reload();
      } else {
        console.error("Request failed with status: " + xhr.status);
      }
    };

    xhr.send(data);
  }

  checkCartAttribute() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const paginationAttribute = cart.attributes.pagination;
        if (paginationAttribute) {
          this.productGrid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
          this.productGrid.classList.add(`grid--${paginationAttribute}-col-desktop`);
          
          // Update active button
          const activeButton = this.querySelector(`[data-items="${paginationAttribute}"]`);
          if (activeButton) {
            this.buttons.forEach(btn => btn.classList.remove('mobile-facets__wrapper-product-per-line__item--active'));
            activeButton.classList.add('mobile-facets__wrapper-product-per-line__item--active');
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  connectedCallback() {
    this.setEventListeners();
    this.checkCartAttribute();
  }
}

if (!customElements.get('product-per-line')) {
  customElements.define('product-per-line', ProductPerLine);
}